import { Fragment } from 'react';

import { CreateAccountPageSteps } from 'config/routes';

import FirstNameDescription from './first_name/FirstNameDescription';
import LastNameDescription from './last_name/LastNameDescription';
import EmailDescription from './email/EmailDescription';
import PasswordDescription from './password/PasswordDescription';
import PasswordConfirmationDescription from './password/PasswordConfirmationDescription';

const mapStepToDescription = (step) => {
  if (step === CreateAccountPageSteps.firstName) return FirstNameDescription;
  if (step === CreateAccountPageSteps.lastName) return LastNameDescription;
  if (step === CreateAccountPageSteps.email) return EmailDescription;
  if (step === CreateAccountPageSteps.password) return PasswordDescription;
  if (step === CreateAccountPageSteps.passwordConfirmation)
    return PasswordConfirmationDescription;
  if (step === CreateAccountPageSteps.request) return Fragment;

  throw new Error('invalid step');
};

export default mapStepToDescription;
